import { IFileFilter } from '../domain/IFileFilter'
import { CuratedFileList } from '../domain/curated-file-list.model'

export class FileFilterHandler {
  private filters: IFileFilter[] = []

  setNext(filter: IFileFilter): FileFilterHandler {
    this.filters.push(filter)
    return this
  }

  handle(files: File[]): CuratedFileList {
    const result: CuratedFileList = { files: files, errors: [] }

    for (const filter of this.filters) {
      const filterResult = filter(result.files)
      result.files = filterResult.files
      result.errors.push(...filterResult.errors)
    }

    return result
  }
}
